










































































































































































































































































































































































































































































































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import { FacilityModule } from '@/store/modules/facility.module'
import { UserModule } from '@/store/modules/user.module'
import { PHONE_MASK, STORAGE_URL, ZIP_MASK } from '@/constants'
import { EOrigin, EUserPermissions, EUserStatus, IFacility, IFacilityCredentials, isNumber, isObj, IUser, US_STATES_LIST } from '@zunta/configurations'
import Api from '@/api'
import Card from '@/components/Card.vue'
import UpdateFacilityModal
  from '@/views/app/management/settings/pages/facility/information/components/UpdateFacilityModal.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import Switcher from '@/components/Switcher.vue'
import InputPassword from '@/components/inputsV2/InputPassword.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import Icon from '@/components/Icon.vue'
import Editable from '@/components/inputsV2/Editable.vue'
import { email, minLength, numeric, required, requiredIf } from 'vuelidate/lib/validators'
import InputFileV2 from '@/components/inputsV2/InputFileV2.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import { getSelectContentLabel, isProductionEnv } from '@/utils/helpers'
import FileInput from '@/components/inputs/FileInput.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import StatusFacilityComplete from '@/components/statuses/StatusFacilityComplete.vue'
import CircleChart from '@/components/chart/CircleChart.vue'
import { VPopover } from 'v-tooltip'
import Confirm from '@/components/Confirm.vue'
import { getFacilityGeneralInfoCompleteLevel } from '@/utils/facility/facilityLevels'
import { Debounce } from 'vue-debounce-decorator'

@Component({
  components: {
    FileInput,
    InputValidator,
    InputFileV2,
    Editable,
    Icon,
    LoaderWrapper,
    InputPassword,
    SelectV2,
    InputV2,
    UpdateFacilityModal,
    Card,
    StatusFacilityComplete,
    CircleChart,
    VPopover,
    Checkbox,
    Switcher,
    Confirm
  }
})
export default class FacilityInfo extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  EUserPermissions: any = EUserPermissions
  EOrigin: any = EOrigin
  user: any = Api.getUser()
  getSelectContentLabel: Function = getSelectContentLabel

  PHONE_MASK: string = PHONE_MASK
  ZIP_MASK: string = ZIP_MASK

  patchFacilityData: Partial<IFacility> = {}
  showNcsIntegrationUpdateConfirmation = false
  originid = ''
  directory = ''
  isLoading: boolean = false
  isLoadingFile: boolean = false

  shouldUpdateFacilityModalOpened: boolean = false
  preventUpdate: boolean = true

  updater: number = 0
  showToggleConfirm: boolean = false
  tooltipText: string = 'Click to Copy'

  get requiredFields () {
    const fields = [{
      value: 'name',
      label: 'Name'
    }, {
      value: 'street',
      label: 'Address'
    }, {
      value: 'city',
      label: 'City'
    }, {
      value: 'state',
      label: 'State'
    }, {
      value: 'zip',
      label: 'Zip Code'
    }, {
      value: 'phone',
      label: 'Phone'
    }, {
      value: 'residentBillingContact',
      condition: this.selectedUserHasAccessToFacility,
      label: 'Billing Contact'
    }, {
      value: 'logo',
      label: 'Logo'
    }]
    if (this.originalFacilityData.origin === EOrigin.PCC) {
      fields.push({
        value: 'username',
        label: 'PCC Username',
        condition: this.facilityCredentialsHaveUsername,
      })
    } else {
      if (!this.originid && !this.directory) {
        fields.push({
          value: 'directory',
          label: 'File Directory'
        },
        {
          value: 'originid',
          label: 'NCS Company Id'
        })
      }
      if (this.directory) {
        fields.push({
          value: 'directory',
          label: 'File Directory'
        })
      }
      if (this.originid) {
        fields.push({
          value: 'originid',
          label: 'NCS CompanyId'
        })
      }
    }
    return fields
  }

  validations (): any {
    return {
      patchFacilityData: {
        name: {
          required
        },
        shortName: {
          // required
        },
        email: {
          email
          // required
        },
        street: {
          // required
        },
        state: {
          // required
        },
        city: {
          // required
        },
        zip: {
          // required,
          numeric,
          minLength: minLength(5)
        },
        phone: {
          // required,
          phone: (val: any) => !val || /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/.test(val)
        },
        website: {
          // required,
          valid: (val: any) => !val || /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/.test(val)
        },
        residentBillingContact: {
          // required
        },
        directory: {
          required: requiredIf(() => !this.originid)
        },
        originid: {
          required: requiredIf(() => !this.directory)
        },
        facilityCredentials: {
          username: {
            // required: requiredIf(() => this.isPcc)
          },
          password: {
            // required: requiredIf(() => this.isPcc)
          }
        }
      }
    }
  }

  get isSuperAdmin () {
    return this.user.isRootAccess()
  }

  get hasEditPermission () {
    return this.user.hasPermissionFor(EUserPermissions.EDIT_FACILITY_INFORMATION)
  }

  get facilityManagersList () {
    return this.$store.state.user.users
  }

  get facilityCompleteLevel () {
    return getFacilityGeneralInfoCompleteLevel(this.originalFacilityData, this.userIds)
  }

  get facilityCredentialsHaveUsername () {
    const facilityCredentials = isObj(this.patchFacilityData.facilityCredentials) ? this.patchFacilityData.facilityCredentials : {}
    return (facilityCredentials as IFacilityCredentials).username
  }

  get completedData () {
    this.updater++
    return [{
      value: 100 - this.facilityCompleteLevel,
      text: '',
      color: '#ffffff'
    },
      {
        value: this.facilityCompleteLevel,
        text: '',
        color: 'currentColor'
      }]
  }

  get statesList () {
    return Object.keys(US_STATES_LIST).map((stateShortName: string) => ({
      value: stateShortName,
      key: stateShortName,
      content: US_STATES_LIST[stateShortName]
    }))
  }

  get facilityManagersListForSelect () {
    if (!this.facilityManagersList || !this.facilityManagersList.length || !this.originalFacilityData) {
      return []
    }

    return this.facilityManagersList
      .filter((manager: IUser) => {
        const isActive: boolean = manager.status === EUserStatus.ACTIVE

        const hasAccessToFacility: boolean =
          manager.isAllFacilities ||
          !!(manager.facilities && manager.facilities.length && manager.facilities.map((Number)).includes(Number(this.originalFacilityData.id)))

        const equalsToSelected: boolean = this.patchFacilityData.residentBillingContact
          ? Number(this.patchFacilityData.residentBillingContact) === manager.id
          : false

        return (isActive && hasAccessToFacility) || equalsToSelected
      })
      .map((manager: IUser) => ({
        key: 'manager' + manager.id,
        value: manager.id,
        content: `${manager.firstName} ${manager.lastName}`
      }))
  }

  get originalFacilityData () {
    return this.$store.state.facility.selectedFacility as IFacility
  }

  get isPcc () {
    return this.originalFacilityData.origin === EOrigin.PCC
  }

  get isNcs () {
    return this.originalFacilityData.origin === EOrigin.NCS
  }

  get isNCSApi () {
    return this.originalFacilityData.origin === EOrigin.NCS && this.originid && isNumber(Number(this.originid))
  }

  get integrationAccountName () {
    return this.isNCSApi ? 'Microsoft' : EOrigin.PCC
  }

  get isManual () {
    return this.originalFacilityData.origin === 'MANUAL'
  }

  get facilityLogoPath () {
    return this.originalFacilityData ? `${STORAGE_URL}?file=` : ''
  }

  get userIds () {
    return this.facilityManagersListForSelect.map((option: any) => option.value)
  }

  get selectedUserHasAccessToFacility () {
    return this.originalFacilityData.residentBillingContact &&
      this.userIds.includes(+this.originalFacilityData.residentBillingContact)
  }

  saveNcsInegration () {
    this.patchFacilityData = { ...this.patchFacilityData, originid: this.originid, directory: this.directory }
    this.save(this.originid ? 'originid' : 'directory')
    this.showNcsIntegrationUpdateConfirmation = false
  }

  updateNcsIntegration (value: string, field: string) {
    // @ts-ignore
    if (value && this.patchFacilityData[field] !== value) {
      this.showNcsIntegrationUpdateConfirmation = true
    }
  }

  focusInput (fieldName: string) {
    if (fieldName === 'logo') {
      // @ts-ignore
      this.$refs[fieldName].isDragOver = true
      // @ts-ignore
      this.$refs[fieldName].focusInput()
      setTimeout(() => {
        // @ts-ignore
        this.$refs[fieldName].isDragOver = false
      }, 1500)
      return
    }
    this.$eventBus.$emit(`focusInput`, fieldName)
  }

  initFacilityData () {
    if (!this.originalFacilityData) {
      return
    }
    this.patchFacilityData = JSON.parse(JSON.stringify(this.originalFacilityData))
    if (!this.patchFacilityData.facilityCredentials) {
      this.patchFacilityData.facilityCredentials = {} as IFacilityCredentials
    }
    this.originid = this.patchFacilityData.originid || ''
    this.directory = this.patchFacilityData.directory || ''
    this.$nextTick(() => {
      this.preventUpdate = false
    })
  }

  async uploadLogo (file: File) {
    if (!this.originalFacilityData) {
      return
    }

    await this.facilityModuleInstance.uploadLogo({
      facilityId: this.originalFacilityData.id!,
      logo: file
    })
    this.preventUpdate = true
    this.initFacilityData()
  }

  async removeLogo () {
    try {
      this.isLoading = true
      await this.facilityModuleInstance.updateFacility({
        id: this.originalFacilityData.id!,
        data: {
          logo: ''
        }
      })
    } finally {
      this.originalFacilityData.logo = ''
      this.preventUpdate = true
      this.initFacilityData()
      this.isLoading = false
    }
  }

  async save (field: string) {
    if (!this.originalFacilityData || !this.hasEditPermission || this.preventUpdate) {
      return
    }

    this.$v.$touch()

    if (this.$v.$anyError || !field) {
      return
    }

    const facField = field as keyof IFacility
    const credsField = field as keyof IFacilityCredentials
    if (
      this.originalFacilityData[facField] === this.patchFacilityData[facField] &&
      this.originalFacilityCredentials[credsField] === this.patchFacilityCredentials[credsField]
    ) {
      return
    }

    try {
      const facilityPayload: any = JSON.parse(JSON.stringify(this.patchFacilityData))
      if (this.patchFacilityData.facilityCredentials) {
        delete (this.patchFacilityData.facilityCredentials as IFacilityCredentials).password
      }
      const facilityCredentialsPayload = facilityPayload.facilityCredentials
      const credentialsChanged = this.didCredentialsChange(facilityCredentialsPayload)

      this.isLoading = true
      delete facilityPayload.logo
      if (isObj<Partial<IFacilityCredentials>>(facilityCredentialsPayload)) {
        if (credentialsChanged) {
          delete facilityCredentialsPayload.id
        }
      }

      let reloadList = false
      if (
        (this.originalFacilityData.name !== this.patchFacilityData.name) ||
        (this.originalFacilityData.shortName !== this.patchFacilityData.shortName)
      ) {
        reloadList = true
        this.$eventBus.$emit('reload-facility-list')
      }
      const res = await this.facilityModuleInstance.updateFacility({
        id: this.originalFacilityData.id!,
        data: {
          ...facilityPayload,
          credentialsChanged: credentialsChanged,
        }
      })
      this.updater++

      if (reloadList) {
        this.$eventBus.$emit('reload-facility-list')
      }

      if (!res) {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          header: `Credentials are incorrect`,
          icon: 'warning'
        })
        return
      }

      if (credentialsChanged) {
        await this.facilityModuleInstance.getFacility(this.originalFacilityData.id)
        this.initFacilityData()
        this.$eventBus.$emit('notify', {
          color: 'var(--status-success-color)',
          header: `Credentials are updated`,
          icon: 'check'
        })
      }
    } finally {
      if (field === 'name') {
        this.$eventBus.$emit('reload-facility-list')
      }
      setTimeout(() => (this.isLoading = false), 300)
    }
  }

  reports: any = []
  contactsReport = ''
  residentsReport = ''
  transactionsReport = ''

  openUpdateFacilityModal () {
    this.shouldUpdateFacilityModalOpened = true
  }

  closeUpdateFacilityModal () {
    this.shouldUpdateFacilityModalOpened = false
  }

  async mounted () {
    this.initFacilityData()
    this.$watch(() => (this.facilityCompleteLevel), () => {
       this.facilityModuleInstance.SET_FACILITY_COMPLETE_LEVEL([
        { type: 'generalInfo', value: this.facilityCompleteLevel }
      ])
    })
    await this.userModuleInstance.getManagementUsersList({ status: EUserStatus.ACTIVE })
  }

  saveManualPCCImport (confirmed: boolean = false) {
    if (isProductionEnv() && !confirmed) {
      this.showToggleConfirm = true
      return
    }
    this.showToggleConfirm = false
    return this.save('useManualPCCImport')
  }

  cancelManualPCCImportChange () {
    this.patchFacilityData.useManualPCCImport = this.originalFacilityData.useManualPCCImport
    this.showToggleConfirm = false
  }

  async uploadCsvContacts (event: any) {
    this.isLoadingFile = true
    const res = await Api.facility.uploadResidentContacts(this.originalFacilityData.id!, event)
    if (res.error) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: res.message,
        header: `Upload resident contact error`,
        icon: 'warning'
      })
    } else {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: '',
        header: `Contacts successfully uploaded`,
        icon: 'check'
      })
    }
    this.isLoadingFile = false
  }

  get patchFacilityCredentials () {
    return (this.patchFacilityData.facilityCredentials || {}) as IFacilityCredentials
  }

  get originalFacilityCredentials () {
    return (this.originalFacilityData.facilityCredentials || {}) as IFacilityCredentials
  }

  didCredentialsChange (facilityCredentialsPayload: IFacilityCredentials | number | undefined) {
    if (!isObj<IFacilityCredentials>(facilityCredentialsPayload)) {
      return false
    }
    return (this.originalFacilityCredentials.password !== facilityCredentialsPayload.password) ||
      (this.originalFacilityCredentials.username !== facilityCredentialsPayload.username)
  }

  @Debounce(300)
  async getOTPCode () {
    const facilityCredentials = this.patchFacilityCredentials
    if (!facilityCredentials || !facilityCredentials.mfaSecret || !facilityCredentials.username) {
      return
    }
    this.tooltipText = 'Request in progress'
    const response = await this.facilityModuleInstance.getOTPCodeForUsername(facilityCredentials.username)
    if (response.error) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        header: `OTP Error`,
        message: response.message,
        icon: 'warning'
      })
    } else {
      navigator.clipboard.writeText(String(response))
      this.tooltipText = 'Copied to Clipboard'
      setTimeout(() => {
        this.tooltipText = 'Click to Copy'
      }, 500)
    }
  }
}
